import { watch } from 'vue';
import { useOrderFormStore } from '@/stores/forms/orderFormStore';
import walletAddressValidator from '@/composables/validations/walletAddressValidator.js';

const { validateWalletByBlockchains } = walletAddressValidator();

export default function useWalletAddressEventValidator() {
  const orderStore = useOrderFormStore();
  /**
   * Watches form wallet address and updates the wallet address validator
   * @param {object} form The form that's values are being watched.
   * @param {object} store The store that the state is to be bound to.
   * @param {object} computed prop that dynamically checks all blockchains by coin combo.
   * @param {function} callback OPTIONAL. Callback to run when complete.
   */
  const watchWalletAddressAndHandleEvents = (
    form,
    store,
    findAllBlockchainCodesByCoins,
    callback,
  ) => {
    watch(
      () => [form.value.walletAddress, form.value.coinType],
      async () => {
        if (!form.value.walletAddress) {
          callback(findAllBlockchainCodesByCoins.value);
          return;
        }

        const hasObject = Boolean(
          findAllBlockchainCodesByCoins.value[0]?.value,
        );

        const validatedBlockchains = await validateWalletByBlockchains(
          form.value.walletAddress,
          hasObject
            ? findAllBlockchainCodesByCoins.value.map((el) => el.value)
            : findAllBlockchainCodesByCoins.value,
        );

        const filteredBlockchains = Object.entries(validatedBlockchains).reduce(
          (acc, [key, value]) => {
            const validBlockchain = findAllBlockchainCodesByCoins.value.find(
              (el) => String(el.value).toLowerCase() === String(key).toLowerCase(),
            );
            if (value && validBlockchain) {
              acc.push(validBlockchain);
            }
            return acc;
          },
          [],
        );
        if (filteredBlockchains.length === 0) {
          callback(['No valid blockchains available']);
        } else {
          // skip for order creation from api
          const {
            merchApiOrderData,
            merchApiOrderData: { blockchain },
          } = orderStore;
          if (merchApiOrderData && blockchain) {
            store.updateValue('blockchain', blockchain);
          }

          callback(filteredBlockchains);
        }

        store.updateValue('walletAddress', form.value.walletAddress);
      },
      { deep: true },
    );
  };

  return {
    watchWalletAddressAndHandleEvents,
  };
}
